import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  reasonModal: {
    '&&': {
      padding: SPACES.xxl,
      paddingTop: SPACES.xxxxxl,
      minWidth: '334px',
      maxWidth: '400px',
      width: '100%',
      minHeight: '300px',

      [theme.breakpoints.down('tablet')]: {
        minWidth: '290px',
        width: '90vw',
      },

      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      justifyContent: 'space-between',
    },
  },
}))
